import { render, staticRenderFns } from "./how-a-c-works-video.vue?vue&type=template&id=3f15bb2e&"
import script from "./how-a-c-works-video.vue?vue&type=script&lang=js&"
export * from "./how-a-c-works-video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports